/* eslint-disable @typescript-eslint/no-explicit-any */
import XLSX from 'xlsx-js-style';
import { posturePart } from 'consts/personnelData';

const usePostureSchoolsXlsx = (xlsxData: any, productNumber: number) => {
  const wb = XLSX.utils.book_new();

  const data = [
    ['Posture 분석통계'], // A1 셀에 제목 추가
    ['부위', '', '지표', '구분', '상세구분', '비율(%)', '인원수(명)'],
    ...xlsxData
  ];

  // 워크시트 객체를 생성합니다.
  const ws = XLSX.utils.aoa_to_sheet(data);

  const dataLength = data[1].length;
  //구분영역  스타일 설정

  ws['A1'].s = { font: { bold: true, sz: 10, name: '맑은 고딕' } };

  for (let col = 0; col < dataLength; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 1, c: col });
    ws[cellAddress].s = {
      font: { bold: true, sz: 8, name: '맑은 고딕' },
      alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
      fill: { fgColor: { rgb: 'e5e5e5' } },
      border: {
        top: { style: 'thin', color: { auto: 1 } },
        bottom: { style: 'thin', color: { auto: 1 } },
        left: { style: 'thin', color: { auto: 1 } },
        right: { style: 'thin', color: { auto: 1 } }
      }
    };
  }
  ws['!cols'] = Array(dataLength).fill({ wch: 20 });

  //A2부터 A17까지의 셀에 대한 스타일, 병합을 설정합니다.
  const mergePatterns = [{ s: { r: 1, c: 0 }, e: { r: 1, c: 1 } }];
  let severityLenght = 0;
  const colDataLength = productNumber === 9 ? 5 : 8;
  let colSeverityDataLegnth = 0;
  let indicatorsLength = 0;

  for (let col = 0; col < dataLength; col++) {
    let startText = '';
    for (let i = 2; i < data.length; i++) {
      //스타일 설정
      const cellAddress = XLSX.utils.encode_cell({ r: i, c: col });

      const horizontal = col <= 4 ? 'center' : 'right';
      ws[cellAddress].s = {
        font: { sz: 8, name: '맑은 고딕' },
        alignment: {
          horizontal: horizontal,
          vertical: 'center',
          wrapText: true
        },
        border: {
          top: { style: 'thin', color: { auto: 1 } },
          bottom: { style: 'thin', color: { auto: 1 } },
          left: { style: 'thin', color: { auto: 1 } },
          right: { style: 'thin', color: { auto: 1 } }
        }
      };

      //병합 설정
      if (col < dataLength - 3) {
        let gap = 0;
        let indicatorDatas: any = null;
        if (col === 0 || col === 1) {
          const innerIndx = posturePart.filter(
            (part: any) => part.value === data[i][0]
          )[0];
          indicatorDatas = innerIndx?.indicators;
          indicatorsLength = indicatorDatas?.length;

          for (const indicatorData of indicatorDatas) {
            if ('severity' in indicatorData) {
              const indicatorsWithSeverity = indicatorData as {
                severity: { key: string; value: string }[];
              };
              severityLenght = indicatorsWithSeverity.severity.length;
            }
          }
          colSeverityDataLegnth = colDataLength * severityLenght;
        }

        if (data[i][col] !== startText) {
          let mergePattern:
            | any
            | {
                s: {
                  r: number;
                  c: number;
                };
                e: {
                  r: number;
                  c: number;
                };
              } = null;
          if (data[i][0] === '근골격지수') {
            if (col === 0) {
              mergePattern = {
                s: { r: i, c: col },
                e: { r: data.length - 1, c: col }
              };
            } else if (col === 2) {
              gap = productNumber === 9 ? 4 : 7 * (col - 1);
              mergePattern = {
                s: { r: i, c: col - 1 },
                e: { r: i + gap, c: col }
              };
            }
          } else {
            if (col === 0) {
              gap = colSeverityDataLegnth * indicatorsLength + i - 1;
              mergePattern = { s: { r: i, c: col }, e: { r: gap, c: col } };
            } else if (col === 1) {
              gap = (colSeverityDataLegnth - 1) * col;
              mergePattern = { s: { r: i, c: col }, e: { r: i + gap, c: col } };
            } else if (col === 2) {
              gap = productNumber === 9 ? 4 : 7 * (col - 1);
              mergePattern = { s: { r: i, c: col }, e: { r: i + gap, c: col } };
            }
          }

          if (col === 3) {
            const number = productNumber === 9 ? 2 : 5;
            gap = data[i][col] === '성별' ? 1 * (col - 2) : number * (col - 2);
            mergePattern = { s: { r: i, c: col }, e: { r: i + gap, c: col } };
          }

          if (mergePattern !== null) mergePatterns.push(mergePattern);
          startText = data[i][col];
        }
      }
    }
  }

  // 병합
  ws['!merges'] = mergePatterns;

  //워크북에 워크시트를 추가합니다.
  XLSX.utils.book_append_sheet(wb, ws, 'Posture 분석통계');

  // 엑셀 파일을 생성합니다.
  XLSX.writeFile(wb, 'Posture 분석통계.xlsx');
};

export default usePostureSchoolsXlsx;
